module.exports = "<div class=\"gray-overlay\">\n  <div id=\"loader-overlay\">\n    <div id=\"loader\">\n      <div class=\"left-wrap\">\n        <div class=\"circle\"></div>\n      </div>\n      <div class=\"right-wrap\">\n        <div class=\"circle\"></div>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"text\" class=\"loader-text\">{{text}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/loader/loader.component.html
// module id = ./src/app/shared/components/loader/loader.component.html
// module chunks = main